<div class="content-with-filled-button">
    <p class="sub-title">{{ copyService.copies.outlay_other_bank_sub_title }}</p>
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div class="box-input">
                <voxel-form-field [id]="banco" [label]="copyService.copies.outlay_other_bank_label" [formGroup]="formGroup"
                msgErr="Campo obligatorio">
                    <vcl-autocomplete id="autoCompleteComponent" [placeholder]="copyService.copies.outlay_other_bank_placeholder" 
                    formControlName="banco" ngDefaultControl>
                        <vcl-option [id]="'id'" *ngFor="let option of options" [value]="option">
                            {{ option.name }}
                        </vcl-option>
                    </vcl-autocomplete>
                </voxel-form-field>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div class="box-input1">
                <voxel-form-field [id]="tipo-cuenta" [label]="copyService.copies.outlay_other_bank_label1" [formGroup]="formGroup"
                msgErr="Campo obligatorio">
                    <vcl-autocomplete id="autoCompleteComponent" [placeholder]="copyService.copies.outlay_other_bank_placeholder" 
                    formControlName="tipocuenta" ngDefaultControl>
                        <vcl-option [id]="'id'" *ngFor="let option2 of options2" [value]="option2">
                            {{ option2 }}
                        </vcl-option>
                    </vcl-autocomplete>
                </voxel-form-field>
            </div>
        </div>
    </div>
    <form id="formCuenta" class="form row" [formGroup]="formGroup">
        <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <vcl-form-field label="{{ copyService.copies.outlay_other_bank_label2 }}"
          msgErr="El número de caracteres no coincide (min. 8, max. 20)">
            <input vclInput placeholder={{copyService.copies.outlay_other_bank_placeholder1}}
              id="inputCuenta" minlength="8" maxlength="20" type="number" 
              formControlName="numerocuenta" ngDefaultControl>  
          </vcl-form-field>
              <!-- (input)="reactiveInputChangePlazo()"  -->

        </div>
    </form>
</div>

<app-controls id="docIntroBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.plazo_monto_next_button" (next)="next()" [nextDisabled]="!formGroup.valid"></app-controls>